import { Badge } from "../../design-system";
import type { ReviewNotice } from "./refine-data";
import "./refine.css";
export function ReviewSummary({
  errors = 0,
  warnings = 0,
  notices = 0,
}: {
  errors?: number;
  warnings?: number;
  notices?: number;
}) {
  return (
    <span className="mrf-checks">
      <Badge tone={errors ? "coral" : "teal"}>
        {errors ? "오류 " + errors : "통과"}
      </Badge>
      <span>경고 {warnings}</span>
      <Badge tone={notices ? "amber" : "neutral"}>검토 {notices}</Badge>
    </span>
  );
}
export function ReviewNotices({ notices = [] }: { notices?: ReviewNotice[] }) {
  return (
    <div className="mrf-notices">
      <p className="mrf-muted">
        자동 검토는 확인을 돕는 안내입니다. 등록을 막는 것은 형식 오류입니다.
      </p>
      {notices.length ? (
        notices.map((n, i) => (
          <article
            key={i}
            className={n.code === "ai_missed" ? "is-highlight" : ""}
          >
            <div>
              <Badge tone={n.level === "warn" ? "amber" : "blue"}>
                {n.code === "ai_missed"
                  ? "AI 보고서가 놓친 항목"
                  : n.level === "warn"
                    ? "검토"
                    : "정보"}
              </Badge>
              {n.line && <small>원고 {n.line}행</small>}
            </div>
            <p>{n.message}</p>
            {n.data?.missing?.map((v, j) => (
              <p className="mrf-removed" key={"m" + j}>
                − 빠진 문장: {v}
              </p>
            ))}
            {n.data?.added?.map((v, j) => (
              <p className="mrf-added" key={"a" + j}>
                + 새 문장: {v}
              </p>
            ))}
          </article>
        ))
      ) : (
        <p>검토 항목이 없습니다.</p>
      )}
    </div>
  );
}
/** Safe text-only markdown preview; never executes HTML supplied by a manuscript. */
export function RefineMarkdown({ body }: { body: string }) {
  return (
    <article className="mrf-markdown">
      {body
        .split("\n")
        .map((line, i) =>
          line.startsWith("# ") ? (
            <h3 key={i}>{line.slice(2)}</h3>
          ) : line.startsWith("## ") ? (
            <h4 key={i}>{line.slice(3)}</h4>
          ) : (
            <p key={i}>{line || "\u00a0"}</p>
          ),
        )}
    </article>
  );
}
